export default {
	menu: {
		notification: '',
		settings: '',
		language: '',
		logout: ''
	}
}